import Service from "@/services/participant";
//import {router} from '@/plugins/router'

export default {
  namespaced: false,
  state: {
    list: {},
  },
  actions: {
    getParticipantList({ dispatch, commit }, id) {
      Service.get(id)
        .then((data) => {
          if(data){
            commit("participantList", data.data);
          }
        })
        .catch((err) => {
          dispatch("alert/error", err, { root: true });
        });
    },
    putParticipant({ dispatch }, payload) {
      Service.put(payload.id, payload.param)
        .then(() => {
          //dispatch("alert/success", "Le participant a été modifié");
          dispatch("getParticipantList", payload.tripId);
        })
        .catch((err) => {
          dispatch("alert/error", err, { root: true });
        });
    },
  },
  mutations: {
    participantList(state, values) {
      let participants = [];
      for (let j in values) {
        if (values[j]["Validation_isUser"] === 1) {
          participants = [...[values[j]], ...participants];
        } else {
          participants.push(values[j]);
        }
      }
      state.list = participants;
    },
  },
};
